import React from "react";
import { PreviewAltCard } from "../../Component";
import { Icon } from "../../Component";
import { Link } from "react-router-dom";
import { getPublicUrl } from "../../../utils/Utils";

const TopListWidget = ({ title, items, metric, link, loading, maxItems = 5, icon }) => {
  const displayItems = items && Array.isArray(items) ? items.slice(0, maxItems) : [];

  const getMetricValue = (item) => {
    if (metric && item[metric] !== undefined && item[metric] !== null) {
      return item[metric];
    }
    if (item.count !== undefined && item.count !== null) return item.count;
    if (item.total !== undefined && item.total !== null) return item.total;
    if (item.quotes_count !== undefined && item.quotes_count !== null) return item.quotes_count;
    if (item.activity_count !== undefined && item.activity_count !== null) return item.activity_count;
    return null;
  };

  const getName = (item) => {
    return item.name || 
           item.organization_name || 
           item.enterprise_name || 
           item.clinic_name || 
           item.title || 
            "Unnamed";
  };

  return (
    <PreviewAltCard className="card-bordered h-100">
      <div className="card-title-group mb-3">
        <div className="card-title">
          <h6 className="title">{title}</h6>
        </div>
        {link && (
          <div className="card-tools">
            <Link to={getPublicUrl(link)} className="btn btn-sm btn-icon btn-trigger">
              <Icon name="arrow-right"></Icon>
            </Link>
          </div>
        )}
      </div>
      <div className="top-list">
        {loading ? (
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "200px" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading</span>
            </div>
          </div>
        ) : displayItems.length > 0 ? (
          <ul className="nk-tb-list is-loose">
            {displayItems.map((item, index) => (
              <li className="nk-tb-item" key={item._id || item.id || `top-${index}`}>
                <div className="nk-tb-col">
                  <span className="tb-lead">
                    <span className="badge badge-dim badge-light me-1">#{index + 1}</span>
                    {icon && <Icon name={icon} className="me-1"></Icon>}
                    <span>{getName(item)}</span>
                  </span>
                  {item.description && (
                    <span className="tb-sub text-soft"><span>{item.description}</span></span>
                  )}
                </div>
                <div className="nk-tb-col nk-tb-col-end">
                  <span className="tb-amount">
                    <span>
                      {(() => {
                        const v = getMetricValue(item);
                        if (v === null || v === undefined || v === "") return "—";
                        const n = Number(v);
                        return Number.isFinite(n) ? n.toLocaleString() : String(v);
                      })()}
                    </span>
                    {metric && getMetricValue(item) != null && getMetricValue(item) !== "" && (
                      <span className="currency currency-usd ms-1 small">{metric.replace(/_/g, " ")}</span>
                    )}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center text-muted py-4">
            <p>No data available</p>
          </div>
        )}
      </div>
    </PreviewAltCard>
  );
};

export default TopListWidget;

